// 記事詳細の閲覧制限（API 403）の表示判定
// 設計書: documents/記事詳細ページ_連携誘導表示_設計.md

const RELATION_CODES_PATTERN = /^[123](,[123])*$/;

// 403 レスポンス本文（例: "1,2"）を条件コードの配列にする。形式外なら null
export function parseRelationCodes(body: unknown): RelationCode[] | null {
  if (typeof body !== 'string' || !RELATION_CODES_PATTERN.test(body)) {
    return null;
  }
  return body.split(',').map(Number) as RelationCode[];
}

export function getRelationState(
  line: LineUser | null,
  mghrwc: MghrwcUser | null,
): RelationState {
  if (!line) return 3;
  if (!mghrwc) return 1;
  return 2;
}

// W連携すれば閲覧できる（条件に W連携が含まれ、まだ W連携済みでない）
export function isRelationResolvable(codes: RelationCode[], state: RelationState): boolean {
  return codes.includes(2) && state !== 2;
}

// W連携すれば閲覧できる場合
export const RELATION_REQUIRED_VIEW: RestrictionView = {
  title: 'ページを表示できません',
  message: '「W（ダブル）連携」を完了している必要があります。',
  button: {
    label: 'W連携を行う',
    toLineAuth: true,
  },
};

// W連携をしても閲覧できない場合
export const RELATION_UNAVAILABLE_VIEW: RestrictionView = {
  title: 'ページを表示できません',
};

// 記事が存在しない場合
export const NOT_FOUND_VIEW: RestrictionView = {
  title: 'ページが見つかりません',
};

export function getRestrictionView(codes: RelationCode[], state: RelationState): RestrictionView {
  return isRelationResolvable(codes, state) ? RELATION_REQUIRED_VIEW : RELATION_UNAVAILABLE_VIEW;
}
